<template>

  <div>
    <!-- v-if="leadData.is_vendor" -->
    <div
      v-if="!leadData.is_vendor"
      id="smartwizard"
      class="sw sw-justified sw-theme-arrows"
    >
      <ul class="nav flex-nowrap overflow-x-scroll">
        <li
          v-for="leadstatus in leadStepStatus"
          :key="leadstatus.id"
          class="nav-item h-70 statusStep"
        >
          <a
            v-if="leadstatus.para_id < leadStepStatus[leadStepStatus.length - 1].para_id"
            class="nav-link d-flex justify-content-center align-items-center inactive"
            href="javascript:void(0)"
            :class="leadData.LeadStatus && leadData.LeadStatus.includes(leadstatus.para_id) ? 'done' : ''"
          >
            <strong>{{ leadstatus.para_value }}</strong>
            <!-- :class="leadData.is_close || leadData.opporunity_status == leadStepStatus[leadStepStatus.length - 1].para_id ? 'danger' : leadstatus.para_id <= leadData.opporunity_status ? 'done' : ''" -->
            <!-- <br>{{ leadstatus.para_desc }} -->
          </a>
          <a
            v-else
            class="nav-link d-flex justify-content-center align-items-center inactive"
            href="javascript:void(0)"
            :class="leadData.LeadStatus && leadData.LeadStatus.includes(leadstatus.para_id) || leadData.is_close ? 'danger' : ''"
          >
            <strong>{{ leadstatus.para_value }}</strong>
          </a>
          <!-- <a
            class="nav-link d-flex justify-content-center align-items-center inactive"
            href="javascript:void(0)"
            :class="leadData.is_close ? 'danger' : leadstatus.para_id <= leadData.lead_status ? 'done' : ''" -->
          <!-- > -->
          <!-- 'active' : leadstatus.para_id < leadData.lead_status ? -->
          <!-- <strong>{{ t(leadstatus.para_value) }}</strong> -->
          <!-- </a> -->
        </li>
      </ul>
    </div>
    <b-card
      no-body
      class="mb-1"
    >
      <template #header>
        <div class="d-flex w-100 justify-content-between">
          <div class="d-flex">
            <h3 class="mb-0">
              {{ leadData.name }} - {{ leadData.vendor_code }}
            </h3>
            <span
              v-if="leadData.status == 'A'"
              class="ml-2"
            > <b-badge
              pill
              variant="success"
            >{{ t('Active') }}</b-badge></span>
            <span
              v-if="leadData.status == 'I'"
              class="ml-2"
            > <b-badge
              pill
              variant="Danger"
            >In-Active</b-badge></span>
          </div>
          <div class="d-flex ">
            <span
              v-if="leadData.opportunity_detail"
              class="position-relative align-self-center"
            >
              <div
                class="custom-quick-tooltip-main btn-link"
              > {{ leadData.opportunity_detail.title }} ({{ leadData.opportunity_detail.count }})

                <div class="custom-quick-tooltip">
                  <opportunity-list-by-lead-id :lead_id="$route.params.id" />
                </div>
              </div>
            </span>
            <!-- <b-button
              v-if="!leadData.is_oportunity && !leadData.is_close && createdParams.lead_id != ''"
              variant="success "
              class="ml-1"
              @click="convertToLead"
            >
              Convert to Lead
            </b-button> -->
            <b-button
              v-if="!leadData.is_close || $route.query.q"
              variant="outline-danger"
              class="ml-1 "
              @click="closeLead"
            >
              {{ t('Close Lead') }}
            </b-button>
            <b-dropdown
              v-if="vendorBtns"
              :text="t(selectUnit)"
              variant="primary"
              class="pl-1 mxh-250"
            >
              <b-dropdown-item
                v-for="vulist in vendorUnitList"
                :key="vulist.vendor_unit_id"
                @click="filterUnitid(vulist.vendor_unit_id, vulist.unit_title)"
              >
                {{ vulist.unit_title }}
              </b-dropdown-item>
            </b-dropdown>
            <b-dropdown
              v-if="!leadData.is_oportunity && !leadData.is_close"
              :text="t('Change Status')"
              variant="primary"
              class="pl-1 zi-12"
              :class="leadData.is_assigned == constants.ALL_SERVICES_ASSIGNED ? $route.query.q ? '' : 'd-none' : ''"
              right
            >
              <b-dropdown-item
                v-for="(status, i) in leadStepStatus"
                :key="status.para_id"
                :class="leadData.LeadStatus && leadData.LeadStatus.includes(status.para_id) ? 'bg-success pointer-event-none' : leadData.lead_status == constants.LEAD_STATUS_FAILURE ? 'bg-danger' : status.para_id == constants.LEAD_STATUS_ASSIGNED ? 'pointer-event-none' : i == leadStepStatus.length - 1 ? '' : status.para_id > leadData.lead_status + 1 ? 'pointer-event-none' : ''"
                @click="changeStatus(status.para_id, status.para_value)"
              >
                <span :class="status.para_id <= leadData.lead_status ? 'text-white' : ''">{{ status.para_value }}</span>
                <feather-icon
                  :icon="status.para_id <= leadData.lead_status ? 'CheckCircleIcon' : ''"
                  class="text-white float-right"
                />
              </b-dropdown-item>
              <!-- <b-dropdown-item
                v-if="!addUnitData.vendor_id"
                @click="$router.push(`/lead/${createdParams.lead_id}/opportunity-list`)"
              >
                Lead List
              </b-dropdown-item> -->
            </b-dropdown>
            <!-- <b-dropdown
              v-else
              :text="t('Action')"
              variant="primary"
              class="pl-1"
              right
            > -->
            <!-- <b-dropdown-item
                v-if="!addUnitData.vendor_id"
                @click="$router.push(`/lead/${createdParams.lead_id}/opportunity-list`)"
              >
                Lead List
              </b-dropdown-item> -->
            <!-- </b-dropdown> -->
          </div>
        </div>
      </template>

      <!-- <b-card-body>
        <table class="mt-2 mt-xl-0 w-100">
          <tr>
            <th class="pb-50">
              <feather-icon
                icon="CopyIcon"
                class="mr-75"
              />
              <span class="font-weight-bold">{{ t('Type') }}</span>
            </th>
            <td class="pb-50">
              {{ leadData.vendor_type_name }}
            </td>
            <th class="pb-50">
              <feather-icon
                icon="UserIcon"
                class="mr-75"
              />
              <span class="font-weight-bold">{{ t('Customer Type') }}</span>
            </th>
            <td class="pb-50">
              {{ leadData.customer_type }}
            </td>
          </tr>
          <tr>
            <th class="pb-50">
              <feather-icon
                icon="UserIcon"
                class="mr-75"
              />
              <span class="font-weight-bold">{{ t('Created By') }}</span>
            </th>
            <td class="pb-50">
              {{ leadData.created_by_name }}
            </td>
            <th class="pb-50">
              <feather-icon
                icon="LinkIcon"
                class="mr-75"
              />
              <span class="font-weight-bold">{{ t('Website') }}</span>
            </th>
            <td class="pb-50">
              <a
                :href="leadData.website"
                target="_blank"
              >{{ leadData.website }}</a>
            </td>
          </tr>
          <tr>
            <th class="pb-50">
              <feather-icon
                icon="PhoneIcon"
                class="mr-75"
              />
              <span class="font-weight-bold">{{ t('Landline No.') }}</span>
            </th>
            <td class="pb-50">
              {{ leadData.landline }} <span v-if="leadData.extention">{{ `- ${leadData.extention}` }}</span>
            </td>
            <th class="pb-50">
              <feather-icon
                icon="CalendarIcon"
                class="mr-75"
              />
              <span class="font-weight-bold">{{ t('Created Date') }}</span>
            </th>
            <td class="pb-50">
              {{ leadData.created_date }}
            </td>
          </tr>
        </table>
      </b-card-body> -->
    </b-card>
    <quick-links
      v-if="Object.keys(leadData).length > 0"
      :vendor_id="leadData.enc_vendor_id"
    />
    <b-row>
      <b-col xl="9">
        <b-card>
          <b-tabs
            class="vendor_details"
            content-class=""
            justified
            pills
            :vertical="verticalTab"
          >
            <b-tab
              active
              :title="t('Contacts')"
            >
              <contacts
                v-if="Object.keys(leadData).length > 0"
                :lead_id="$route.params.id"
                :activity_ids="activity_ids"
                :service_data="leadData.LeadServiceData"
                :is_edit="leadData.is_edit ? leadData.is_edit : 0"
              />
            </b-tab>
            <!-- <b-tab
            title="Units"
          > <units
            v-if="Object.keys(leadData).length > 0"
            :units="leadData.VendorAddress"
          /></b-tab> -->
            <b-tab :title="t('Documents')">
              <documents
                v-if="Object.keys(leadData).length > 0"
                :activity_ids="activity_ids"
                :is_edit="leadData.is_edit ? leadData.is_edit : 0"
              />
            </b-tab>
            <b-tab :title="t('Reminder')">
              <reminders
                v-if="Object.keys(leadData).length > 0"
                :activity_ids="activity_ids"
                :is_edit="leadData.is_edit ? leadData.is_edit : 0"
              />
            </b-tab>
            <b-tab :title="t('Remarks')">
              <remarks
                v-if="Object.keys(leadData).length > 0"
                :close_remark="leadData.close_remark"
                :activity_ids="activity_ids"
                :remarkmodaltitle="remarkmodaltitle"
                :date_limit="leadData.activity_date_limit "
                :is_edit="leadData.is_edit ? leadData.is_edit : 0"
              />
            </b-tab>
            <b-tab
              v-if="leadData.is_assigned !== constants.ALL_SERVICES_ASSIGNED ? true : $route.query.q && !leadData.is_oportunity && checkPermission(constants.ASSIGN_SERVICE_LEAD) && Object.keys(leadData).length > 0"
              :title="t('Assign Services')"
            >
              <assign-services
                v-if="leadData.LeadServiceData"
                :services="leadData.LeadServiceData"
              />
            </b-tab>
            <b-tab
              v-if="Object.keys(leadData).length > 0"
              :title="t('Assign Log')"
            >
              <assign-log
                :activity_ids="activity_ids"
              />
            </b-tab>
            <!-- <b-tab title="Activities">
              <activities :id="vendor_id" />
            </b-tab> -->
          </b-tabs>
        </b-card>
      </b-col>
      <b-col
        xl="3"
        class="pl-md-0 h-100"
      >
        <b-card
          id="activity"
          class="activity-h-scroll"
        >
          <activity
            v-if="Object.keys(leadData).length > 0 && leadData.is_edit"
            :is_edit="leadData.is_edit ? leadData.is_edit : 0"
            :contacts="leadData.VendorContact"
            :data_ids="activity_ids"
            :date_limit="leadData.activity_date_limit"
            :editactivitydata="editActivityData"
          />
          <activities
            :is_edit="leadData.is_edit ? leadData.is_edit : 0"
            :dataids="activity_ids"
            @getActivityById="getActivityById"
          />

        </b-card>
      </b-col>
    </b-row>
    <add-unit
      :addunitdata="addUnitData"
      @loadUnits="loadUnits"
    />
    <close-lead
      :data_ids="activity_ids"
      @refreshLeadData="refreshLeadData"
    />
    <change-status
      :activity_ids="activity_ids"
      :date_limit="leadData.activity_date_limit"
      :remarkmodaltitle="remarkmodaltitle"
    />
  </div>
</template>

<script>
import {
  BCard, /* BCardBody, */ BTabs, BTab, BDropdown, BDropdownItem, BBadge, BRow, BCol, VBToggle,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { useUtils } from '@core/libs/i18n'
import checkPermissions from '@/utils/checkPermissons'
import Contacts from '../../Vendor/VendorTabs/Contacts.vue'
// import Units from './VendorTabs/Units.vue'
import Reminders from '../../Vendor/VendorTabs/Reminders.vue'
import Activity from '../../Vendor/Activity.vue'
import Remarks from '../../Vendor/VendorTabs/Remarks.vue'
import Documents from '../../Vendor/VendorTabs/Documents.vue'
import Activities from '../../Vendor/VendorTabs/Activities.vue'
import { showLoader, hideLoader } from '@/utils/common'
import store from '@/store'
import AddUnit from '../../Vendor/Units/AddUnit.vue'
import CloseLead from '../../Vendor/CloseLead.vue'
import constants from '@/constants'
import AssignServices from '../../Vendor/AssignServices.vue'
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'
import AssignLog from '../../Vendor/VendorTabs/AssignLog.vue'
import QuickLinks from '../../Dashboard/QuickLinks.vue'
import ChangeStatus from '../../Vendor/VendorTabs/ChangeStatus.vue'
import OpportunityListByLeadId from './OpportunityListbyLeadId.vue'

export default {
  components: {
    Activity,
    BCard,
    // BCardBody,
    BTabs,
    BRow,
    BCol,
    BTab,
    Contacts,
    Reminders,
    BBadge,
    Remarks,
    Documents,
    Activities,
    BDropdown,
    BDropdownItem,
    AddUnit,
    CloseLead,
    AssignServices,
    FeatherIcon,
    AssignLog,
    QuickLinks,
    ChangeStatus,
    OpportunityListByLeadId,
  },
  directives: {
    'b-toggle': VBToggle,
  },
  setup() {
    const { t } = useUtils()
    return { t }
  },
  data() {
    return {
      leadStepStatus: [],
      constants,
      show: false,
      remarkmodaltitle: constants.ADD_REMARK_TEXT,
      editActivityData: [],
      canChangeStatus: false,
      activity_ids: {
        activity_for_id: this.$route.params.id,
        activity_for: constants.LEAD,
        lead_id: this.$route.params.id,
        vendor_id: '',
        unit_id: '',
      },
      addUnitData: {
        vendor_id: '',
      },
      createdParams: {
        vendor_id: '',
        lead_id: this.$route.params.id,
      },
      leadData: {},
      vendorBtns: false,
      vendorUnitList: [],
      verticalTab: false,
      selectUnit: 'Select Unit',
    }
  },
  mounted() {
    showLoader()
    if ('q' in this.$route.query && this.$route.query.q) {
      this.canChangeStatus = true
    }
    this.createdParams.lead_id = this.$route.params.id
    this.activity_ids.lead_id = this.$route.params.id
    this.activity_ids.unit_id = ''
    this.activity_ids.vendor_id = ''
    this.getLeadById()
    this.getLeadStatus()
    window.addEventListener('resize', () => {
      if (window.innerWidth <= 768) {
        this.verticalTab = true
      } else {
        this.verticalTab = false
      }
    })
    if (window.innerWidth <= 768) {
      this.verticalTab = true
    } else {
      this.verticalTab = false
    }
    this.$root.$on('refreshLeadData', () => {
      this.getLeadById()
    })
  },
  methods: {
    checkPermission(val) {
      return checkPermissions(val)
    },
    async refreshLeadData() {
      showLoader()
      await this.getLeadById()
      this.getLeadStatus()
      hideLoader()
    },
    async getLeadStatus() {
      await store.dispatch('vendorStore/leadStepStatus').then(response => {
        this.leadStepStatus = response.data.data
      })
    },
    async getActivityById(id) {
      showLoader()
      await store.dispatch('activityStore/getActivityById', { activity_id: id }).then(response => {
        this.editActivityData = response.data.data
        document.getElementById('activity').scrollTop = 0
      })
      hideLoader()
    },
    async getLeadById() {
      await store.dispatch('ManageLeads/getLeadDataById', this.createdParams).then(response => {
        this.leadData = response.data.data
        hideLoader()
      }).catch(() => {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Something Went Wrong',
            icon: 'Danger',
            variant: 'danger',
            text: '',
          },
        })
        hideLoader()
      })
    },
    getVendorUnitList() {
      store.dispatch('vendorStore/getVendorUnitList', this.createdParams).then(response => {
        this.vendorUnitList = response.data.data.data
      }).catch(() => {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Something Went Wrong',
            icon: 'Danger',
            variant: 'danger',
            text: '',
          },
        })
      })
    },
    filterUnitid(unitId, unitTitle) {
      this.selectUnit = unitTitle
      this.activity_ids.activity_for = constants.VENDOR_UNIT
      this.activity_ids.unit_id = unitId
      showLoader()
      store.dispatch('vendorStore/getVendorById', { vendor_id: this.createdParams.vendor_id, vendor_unit_id: unitId }).then(response => {
        this.leadData = response.data.data
      }).catch(() => {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Something Went Wrong',
            icon: 'Danger',
            variant: 'danger',
            text: '',
          },
        })
        hideLoader()
      })

      hideLoader()
    },

    async changeStatus(statusid, statusTitle) {
      showLoader()
      this.remarkmodaltitle = constants.CHANGE_STATUS_ACTIVITY_MODAL_TITLE
      this.$bvModal.show('changeStatusModal')
      this.$root.$emit('getstatusid', statusid, statusTitle)
      hideLoader()
    },

    addUnit() {
      this.$bvModal.show('addUnit')
    },
    closeLead() {
      this.$bvModal.show('closeLeadModal')
    },
    loadUnits() {
      this.getVendorUnitList()
    },
    unitList(vid) {
      this.$router.push(`/vendor/${vid}/unit-list`)
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
<style scoped lang="css">
@import url('https://cdn.jsdelivr.net/npm/smartwizard@5/dist/css/smart_wizard_all.min.css');
.custom-quick-tooltip-main{
  cursor: pointer;
     position: relative;
}
.custom-quick-tooltip{
  display: none;
}
/* .custom-quick-tooltip-main::after{
  content: '';
    padding-top: 10px;
    border-top: 6px  solid;
    transform: rotate(0deg) translate(50%);
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    position: absolute;
    left: 0;
}
.custom-quick-tooltip-main::after{
    display: none;
  } */
.custom-quick-tooltip{
  position: absolute;
  width: max-content;
  height: auto;
  align-items: center;
  right: 0;
  border-radius: 5px;
  background: #ffffff;
  margin-bottom: 0;
  border-bottom: 1px solid rgba(34, 41, 47, 0.125);
  box-shadow: 0 4px 24px 0 rgb(34 41 47 / 35%);
  z-index: 999;
}
.custom-quick-tooltip-main:hover .custom-quick-tooltip {
  display: block;
}
/* .custom-quick-tooltip-main:hover::after {
  display: block;
} */

</style>
<style>

.tabs ul.nav li.nav-item a.nav-link {
  white-space: nowrap;
}
.mxh-250 ul.dropdown-menu{
  max-height: 250px;
  overflow-y: scroll;
}
.card {
  margin-bottom: 1rem !important;
}
.mxh-250 ul.dropdown-menu::-webkit-scrollbar{
  display: none;
}
.activity-h-scroll{
  /* height: 455px; */
  min-height: 455px;
  height: calc(100vh - 368px);
  overflow: auto;
}
.activity-h-scroll::-webkit-scrollbar{
    display: none;
}
 .nav-pills.nav-justified .nav-link {
    border: 1px solid #7367f0;
}
 .nav-pills.nav-justified .nav-item {
    display: table;
    position: relative;
}
.tabs.vendor_details .tab-pane.active:not(.tab-card-fixed-height .tabs *){
    border: 2px solid rgb(115, 103, 240);
    padding: 1rem;
    border-radius: 10px;
    overflow-y: auto;
    height: 100%;
}
.tabs.vendor_details .nav-link.active:not(.tab-card-fixed-height .tabs *){
  position: relative;
}

.tabs.vendor_details .nav-link.active:not(.tab-card-fixed-height .tabs *):after {
    content: "";
    position: absolute;
    left: auto;
    z-index: 11;
    display: block;
    width: 12px;
    height: 12px;
    background: white;
    border-top: 2px solid #7367f0;
    border-left: 2px solid #7367f0;
    top: 42px;
    right: 50%;
    transform: rotate(45deg) translateX(50%);
}
.dark-layout .tabs.vendor_details .nav-link.active:not(.tab-card-fixed-height .tabs *):after {
  background: #283046;
}
.h-70{
  height: 70px;
}
.overflow-x-scroll{
  overflow-x: scroll !important;
}
.overflow-x-scroll::-webkit-scrollbar{
  display: none;
}
.statusStep a::after {
    top: 0 !important;
    margin-top: 0 !important;
    margin-left: 0 !important;
    border-top: 35px solid transparent !important;
    border-bottom: 35px solid transparent !important;
}
.statusStep a::before {
    top: 0 !important;
    margin-top: 0 !important;
    margin-left: 1px !important;
    border-top: 35px solid transparent !important;
    border-bottom: 35px solid transparent !important;
    border-left: 30px solid #ddd;
}
.tab-pane.active {
  position: relative;
}
@media (max-width: 768px) {
  .tabs.vendor_details .nav-link.active:not(.tab-card-fixed-height .tabs *):after {
    left: auto !important;
    top: 50% !important;
    right: -32px !important;
    transform: rotate(315deg) translateX(50%) !important;
}
}
</style>
